import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useServiceRenewalReminders, ServiceRenewalReminderListItem } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<ServiceRenewalReminderListItem>
      useData={useServiceRenewalReminders}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions: (
          item: ServiceRenewalReminderListItem,
          onDelete: (id: number) => void,
          colors?: unknown,
          listContext?: unknown,
          options?: { canDelete?: boolean }
        ) => getTableActions(item, onDelete, colors, listContext, options),
      }}
    />
  );
};

export default List;
